export default {
  SET_USER_ID: (state, userId) => { state.userId = userId; },
  SET_EMAIL: (state, email) => { state.email = email; },
  SET_NAME: (state, name) => { state.name = name; },
  SET_PHONE: (state, phone) => { state.phone = phone; },
  SET_MEMBER_TYPE: (state, memberType) => { state.memberType = memberType; },
  SET_LOGGED: (state, logged) => { state.logged = logged; },
};
